export default __webpack_public_path__ + "static/media/icon.3838c3b1.svg";